"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var core_1 = require("@angular/core");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var SummaryPageConfigsHelperService = /** @class */ (function () {
    function SummaryPageConfigsHelperService(kbService, formManagementService, sessionDataProvider) {
        this.kbService = kbService;
        this.formManagementService = formManagementService;
        this.sessionDataProvider = sessionDataProvider;
        this._acceptableMetaFields = [
            idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER,
            idm_kb_service_client_js_1.MetaFieldType.STRING,
            idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE,
            idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING,
            idm_kb_service_client_js_1.MetaFieldType.INTEGER,
            idm_kb_service_client_js_1.MetaFieldType.DECIMAL,
            idm_kb_service_client_js_1.MetaFieldType.DOCUMENT,
            idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING,
            idm_kb_service_client_js_1.MetaFieldType.DATE,
            idm_kb_service_client_js_1.MetaFieldType.BOOLEAN,
            idm_kb_service_client_js_1.MetaFieldType.MONEY,
            idm_kb_service_client_js_1.MetaFieldType.DATE_TIME,
            idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT
        ];
    }
    SummaryPageConfigsHelperService.prototype.getFormsOfCategory = function (category, type) {
        var _this = this;
        return this.sessionDataProvider.getCurrentLanguage().switchMap(function (currentLanguage) {
            return _this.formManagementService.loadFormsByCategoryAndType(category, type).map(function (forms) {
                // filter only main forms
                return forms
                    .filter(function (value) { return value.entityTypeId === 1; })
                    .map(function (form) {
                    return { id: form.id, name: form.name.getValue(currentLanguage.getId()) };
                });
            });
        });
    };
    /**
     * Loads entity's fields and custom calculated fields (for given entity)
     *
     * @param entityCategoryName Entity's category name
     * @param acceptableMetaFields Type of fields to load
     */
    SummaryPageConfigsHelperService.prototype.getFieldsByEntity = function (entityCategoryName, acceptableMetaFields) {
        var _this = this;
        acceptableMetaFields = acceptableMetaFields || this._acceptableMetaFields;
        return entityCategoryName ? this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(entityCategoryName))
            .pipe(operators_1.switchMap(function (metaCategory) {
            return _this.kbService.getMetaFields(entityCategoryName).pipe(operators_1.map(function (metaFields) {
                return metaFields.filter(function (metaField) {
                    return metaCategory.getSearchableFieldIds().find(function (field) { return field.getSystemName() === metaField.getSystemName(); })
                        && acceptableMetaFields.indexOf(metaField.getType()) !== -1;
                });
            }));
        }))
            : Observable_1.Observable.of([]);
    };
    SummaryPageConfigsHelperService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_form_management_ui_1.FormManagementService,
            idm_session_data_provider_api_js_1.SessionDataProvider])
    ], SummaryPageConfigsHelperService);
    return SummaryPageConfigsHelperService;
}());
exports.SummaryPageConfigsHelperService = SummaryPageConfigsHelperService;
//# sourceMappingURL=summary-page-configs-helper.service.js.map